import React, {FC} from 'react';
import {CalendarOutlined, CarOutlined, EnvironmentOutlined, StopOutlined} from '@ant-design/icons';
import {Card, List} from 'antd';
import {AuctionCardModelType} from '@joyrideautos/ui-models/src/presentation/auctionCard/AuctionCardModel';
import {observer} from 'mobx-react-lite';
import {Favorite} from '@joyrideautos/web-common-components/src/components/favorite/Favorite';
import RequestAccessLink from '@joyrideautos/web-common-components/src/components/requestAccess/RequestAccessLink';
import ViewAuctionButton from '../viewAuctionButton/ViewAuctionButton';
import LiveTag from '@joyrideautos/web-common-components/src/components/LiveTag';
import {Routes} from '../../../Routes';
import {NavLink} from '@joyrideautos/web-common-components/src/router/Router';

const {Meta} = Card;

const getGroupItems = (model: AuctionCardModelType, showStartDate: boolean) => {
    const items: any[] = [];

    if (model.isRestricted) {
        items.push({
            color: 'orange',
            label: 'Restricted',
            icon: <StopOutlined />,
        });
    }
    if (showStartDate) {
        items.push({
            label: model.formattedStartDate,
            icon: <CalendarOutlined />,
        });
    }
    if (!model.isRestricted) {
        const count = model.itemsCount;
        items.push({
            label: count > 0 || model.isEnded ? `${model.itemsCount} vehicles` : `Coming soon`,
            icon: <CarOutlined />,
        });
    }

    if (model.location) {
        items.push({
            label: model.location,
            icon: <EnvironmentOutlined />,
        });
    }

    return items;
};

interface AuctionCardProps {
    model: AuctionCardModelType;
    title?: string;
    onClickAction?: () => void;
    isAuthenticated: boolean;
}

export const AuctionCard: FC<AuctionCardProps> = observer(
    ({model, title, onClickAction = () => {}, isAuthenticated}) => {
        return (
            <NavLink
                to={Routes.AUCTION_OCCURRENCE({
                    pathParams: {
                        regionId: model.auction.regionId,
                        auctionId: model.auction.auctionId,
                    },
                })}>
                <Card
                    data-testid="auction-card-item"
                    data-auctionid={model.auction.auctionId}
                    data-regionid={model.auction.regionId}
                    data-sellerid={model.sellers}
                    data-auction-status={model.auctionStatus}
                    data-vehicles-listed={model.itemsCount}
                    hoverable
                    className="card-item"
                    onClick={onClickAction}>
                    <div className="holder">
                        <Meta title={<span>{title || model.title}</span>} />
                        {isAuthenticated && (
                            <Favorite
                                isFavorite={model.isFavorite}
                                toggleFavorite={() => model.toggleFavorite()}
                                className="no-circle"
                            />
                        )}
                    </div>
                    <div className="ml--5 mb-10">{model.isLive && <LiveTag text={model.liveAuctionTagText} />}</div>
                    <List itemLayout={'horizontal'} className="list horizontal list-desc" split={false}>
                        {getGroupItems(model, !model.auction.shouldHideAuctionDate && title !== undefined).map(
                            (item, i) => (
                                <List.Item className={`item ${item.color || ''}`} key={i}>
                                    {item.icon}
                                    {item.label}
                                </List.Item>
                            )
                        )}
                    </List>
                    <div className="card-bottom">
                        <div className="card-left"></div>
                        <div className="card-right">
                            {model.shouldShowRequestAccessButton ? (
                                <RequestAccessLink />
                            ) : (
                                <ViewAuctionButton auction={model.auction} />
                            )}
                        </div>
                    </div>
                </Card>
            </NavLink>
        );
    }
);
